var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g2, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScientist2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1747,
    height: 923,
    viewBox: "0 0 1747 923",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1747,
    height: 921,
    fill: "#005D5F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_58_6284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1747,
    height: 921
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1747,
    height: 921,
    fill: "#005D5F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_58_6284)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 862.5,
    cy: 89.5,
    r: 610.5,
    fill: "black",
    fillOpacity: 0.29
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.191 537.511H264.982V806.948H353.191V537.511Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M515.174 406H103V746.806H515.174V406Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M487.109 430.058H131.869V723.551H487.109V430.058Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.047 499.823L317.105 579.211L243.331 620.108",
    stroke: "#828282",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M370.833 504.636L317.106 579.212L342.767 676.241",
    stroke: "#828282",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317.106 579.211L432.579 644.966",
    stroke: "#828282",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.671 493.408C217.671 507.842 205.642 519.87 191.208 519.87C176.774 519.87 164.746 507.842 164.746 493.408C164.746 478.974 176.774 466.945 191.208 466.945C205.642 466.945 217.671 478.974 217.671 493.408Z",
    fill: "#DFE33D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.597 620.109C270.597 634.543 258.568 646.571 244.134 646.571C229.7 646.571 217.671 634.543 217.671 620.109C217.671 605.675 229.7 593.646 244.134 593.646C258.568 592.844 270.597 604.873 270.597 620.109Z",
    fill: "#DFE33D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M398.097 504.633C398.097 519.067 386.069 531.096 371.635 531.096C357.201 531.096 345.172 519.067 345.172 504.633C345.172 490.199 357.201 478.171 371.635 478.171C386.069 478.171 398.097 490.199 398.097 504.633Z",
    fill: "#DFE33D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M459.042 644.964C459.042 659.399 447.014 671.427 432.58 671.427C418.146 671.427 406.117 659.399 406.117 644.964C406.117 630.53 418.146 618.502 432.58 618.502C447.014 618.502 459.042 630.53 459.042 644.964Z",
    fill: "#DFE33D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M342.766 702.701C357.381 702.701 369.228 690.853 369.228 676.238C369.228 661.623 357.381 649.775 342.766 649.775C328.151 649.775 316.303 661.623 316.303 676.238C316.303 690.853 328.151 702.701 342.766 702.701Z",
    fill: "#DFE33D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M483.251 802.091H482.086C477.817 802.091 474.323 798.598 474.323 794.328V715.528H491.209V794.328C491.015 798.598 487.521 802.091 483.251 802.091Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M474.129 747.358V793.551C474.129 798.209 477.817 801.897 482.475 801.897C487.133 801.897 490.821 798.209 490.821 793.551V747.164H474.129V747.358Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M493.926 712.812H471.218V728.727H493.926V712.812Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M515.275 802.091C510.617 802.091 506.929 798.404 506.929 793.746V715.528H523.815V793.551C523.815 798.21 519.933 802.091 515.275 802.091Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M506.929 747.358V793.551C506.929 798.209 510.617 801.897 515.275 801.897C519.933 801.897 523.621 798.209 523.621 793.551V747.164H506.929V747.358Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M526.726 712.812H504.018V728.727H526.726V712.812Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M548.076 802.091C543.418 802.091 539.731 798.404 539.731 793.746V715.528H556.616V793.551C556.616 798.21 552.735 802.091 548.076 802.091Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M539.731 747.358V793.551C539.731 798.209 543.418 801.897 548.076 801.897C552.735 801.897 556.422 798.209 556.422 793.551V747.164H539.731V747.358Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M559.333 712.812H536.625V728.727H559.333V712.812Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M580.877 802.091C576.219 802.091 572.531 798.404 572.531 793.746V715.528H589.417V793.551C589.417 798.21 585.535 802.091 580.877 802.091Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M572.531 747.358V793.551C572.531 798.209 576.219 801.897 580.877 801.897C585.535 801.897 589.223 798.209 589.223 793.551V747.164H572.531V747.358Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M592.134 712.812H569.425V728.727H592.134V712.812Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M606.496 737.267H459.766V742.313H606.496V794.328H452.585V806.362H616.589V803.45V794.328V742.313V737.267H606.496Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.97 177.605L1306.75 228.158C1306.75 228.158 1334.55 226.193 1342.7 209.903C1350.84 193.614 1347.19 172.269 1347.19 172.269L1343.54 152.89C1343.54 152.89 1329.21 145.307 1314.33 154.294C1299.73 163.282 1301.97 177.605 1301.97 177.605Z",
    fill: "#B5B5B5",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1500.25 339.657L1398.02 314.661L1347.47 171.988C1347.47 171.988 1335.39 194.456 1326.97 204.567C1318.54 214.678 1301.97 224.227 1301.97 224.227C1301.97 224.227 1319.1 317.751 1325.28 347.802C1331.18 377.853 1332.02 382.908 1339.89 389.93C1347.75 396.67 1440.43 455.087 1440.43 455.087C1440.43 455.087 1409.54 512.662 1406.17 553.105C1402.8 593.547 1400.27 640.73 1400.27 640.73C1400.27 640.73 1475.82 520.526 1503.34 485.138C1530.87 450.032 1542.1 396.67 1535.92 369.146C1529.46 342.185 1500.25 339.657 1500.25 339.657Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1464.02 367.182L1440.15 455.65L1422.74 350.893",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1395.22 317.189C1395.22 317.189 1368.53 326.738 1364.32 357.632",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.4 317.189C1376.4 317.189 1343.82 323.93 1342.13 358.475",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1497.45 373.079L1454.48 462.39L1464.02 478.679L1442.4 496.092L1436.5 529.514",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1651.07 262.703C1651.07 262.703 1701.62 278.993 1718.2 310.729C1734.48 342.465 1694.88 400.04 1688.99 421.665C1683.09 443.01 1691.51 450.874 1699.38 444.976C1707.24 439.078 1715.67 450.874 1707.24 464.636C1698.54 478.398 1651.35 468.006 1635.91 460.423C1620.46 452.559 1623.83 401.163 1632.54 367.742C1641.24 334.32 1651.35 296.405 1646.3 280.116C1640.68 263.546 1651.07 262.703 1651.07 262.703Z",
    fill: "#010101",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1490.99 192.771C1490.99 192.771 1465.99 222.822 1464.3 234.898C1462.62 246.975 1463.46 253.715 1463.46 253.715C1463.46 253.715 1451.39 267.477 1448.86 269.162C1446.33 270.847 1437.62 275.903 1442.96 282.924C1448.02 289.664 1456.72 289.664 1456.72 289.664C1456.72 289.664 1455.88 316.345 1458.41 328.422C1460.93 340.499 1466.27 344.712 1475.54 345.554C1485.09 346.397 1496.88 346.397 1496.88 346.397L1506.43 394.422L1494.36 457.052L1583.67 359.877C1583.67 359.877 1574.96 324.771 1574.96 317.75C1574.96 311.009 1587.88 298.09 1576.65 261.86C1565.69 226.192 1490.99 192.771 1490.99 192.771Z",
    fill: "#FFD2D2",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1577.77 284.609C1577.77 284.609 1562.32 289.665 1558.11 278.712C1553.9 267.477 1560.64 253.716 1539.29 241.639C1517.95 229.562 1480.03 221.137 1472.17 201.196C1464.3 181.537 1473.01 160.754 1485.09 158.226C1497.16 155.698 1511.77 162.439 1534.8 163.281C1558.11 164.124 1626.08 163.843 1647.42 196.422C1668.77 229.001 1648.26 287.699 1642.08 300.618C1636.19 313.537 1636.19 346.959 1611.19 348.644C1586.19 350.329 1569.06 331.512 1567.38 317.75C1565.69 304.55 1577.77 284.609 1577.77 284.609Z",
    fill: "#020202",
    stroke: "black",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1583.67 274.498L1460.09 232.37C1460.09 232.37 1437.62 246.132 1453.35 264.106L1516.82 284.609L1583.11 282.923L1583.67 274.498Z",
    fill: "white"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1583.67 274.498L1460.09 232.37C1460.09 232.37 1437.62 246.132 1453.35 264.106L1516.82 284.609L1583.11 282.923L1583.67 274.498Z",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1583.67 274.498L1460.09 232.37",
    stroke: "#005D5F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1529.46 259.052L1516.54 284.609",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1561.2 290.788C1563.73 290.788 1586.19 260.737 1597.15 269.443C1608.38 278.15 1597.99 309.043 1584.23 314.941C1570.47 320.839 1559.23 306.235 1559.23 306.235",
    fill: "#B5B5B5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1561.2 290.788C1563.73 290.788 1586.19 260.737 1597.15 269.443C1608.38 278.15 1597.99 309.043 1584.23 314.941C1570.47 320.839 1559.23 306.235 1559.23 306.235",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1478.07 256.524C1478.07 260.737 1479.47 264.388 1481.44 264.388C1483.4 264.388 1484.81 261.018 1484.81 256.524C1484.81 252.311 1483.4 248.66 1481.44 248.66C1479.47 248.66 1478.07 252.03 1478.07 256.524Z",
    fill: "#005D5F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1586.19 350.049C1586.19 350.049 1541.54 387.121 1516.54 427.283C1491.55 467.726 1428.07 539.905 1417.68 563.777C1407.29 587.931 1398.87 612.645 1398.87 633.429C1398.87 653.931 1397.18 810.365 1397.18 813.736C1397.18 817.106 1397.18 921.864 1397.18 921.864H1660.9C1660.9 921.864 1644.61 696.059 1644.61 647.752C1644.61 599.726 1665.11 555.913 1649.67 487.105C1634.22 418.858 1608.66 379.257 1586.19 350.049Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1603.33 375.044L1508.12 506.483L1483.96 498.619L1485.65 527.828L1425.55 559.564",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1423.3 809.522H1562.04V831.71H1434.53",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.57 275.902H1276.41C1279.79 275.902 1282.31 273.094 1282.31 270.004V232.37H1269.39V270.004C1269.39 273.375 1272.2 275.902 1275.57 275.902Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.3 224.507H1285.4V237.426H1266.3V224.507Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.13 155.137C1210.13 155.137 1203.39 165.81 1204.24 171.988C1205.08 178.167 1214.35 205.691 1217.16 206.252C1219.96 206.814 1220.53 203.444 1219.68 193.614C1218.84 184.065 1217.16 177.605 1217.16 174.797C1217.44 171.988 1215.47 149.239 1210.13 155.137Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.61 142.218C1339.61 142.218 1350.56 161.316 1342.42 172.55C1334.27 183.503 1316.58 184.627 1316.58 184.627C1316.58 184.627 1313.77 206.252 1309.28 209.622C1305.06 212.993 1294.39 227.878 1292.99 233.214C1291.58 238.55 1281.47 231.81 1281.47 227.316C1281.47 223.103 1288.77 205.69 1290.74 200.916C1292.7 196.142 1288.21 183.222 1286.81 178.729C1285.4 174.516 1284 172.55 1284 172.55C1284 172.55 1269.96 186.031 1268.55 193.614C1267.15 201.197 1271.08 229.563 1267.15 232.933C1263.22 236.303 1253.1 235.461 1251.14 229.563C1249.17 223.665 1245.8 190.244 1245.8 184.346C1245.8 178.448 1255.07 158.788 1255.07 158.788C1255.07 158.788 1240.19 173.673 1239.62 179.01C1239.06 184.346 1243.56 218.048 1241.03 218.891C1238.5 219.733 1234.85 221.418 1231.48 218.329C1228.11 215.52 1225.3 207.656 1225.3 207.656C1225.3 207.656 1215.75 185.188 1211.82 174.516C1207.89 163.843 1204.52 152.048 1213.22 147.554C1221.93 143.341 1228.67 139.409 1253.1 129.86C1277.54 120.311 1312.36 113.009 1324.72 122.277C1337.08 131.546 1339.61 142.218 1339.61 142.218Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.58 184.346L1318.26 149.801",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.86 171.988C1316.86 171.988 1335.96 171.426 1337.92 146.992",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.68 193.613C1219.68 193.613 1213.5 175.358 1218.84 166.651C1224.18 157.945 1244.4 144.464 1244.4 144.464",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1354.77 480.082C1353.09 478.959 1323.04 447.222 1322.47 444.975C1321.91 442.729 1321.35 412.116 1317.98 405.375C1314.61 398.635 1303.38 378.694 1302.81 372.516C1302.25 366.337 1302.25 345.273 1302.81 337.971C1303.38 330.669 1296.07 330.107 1291.02 336.847C1285.96 343.588 1284.84 353.137 1284.84 361.562C1284.84 369.988 1284.28 376.728 1283.15 378.413C1282.03 380.099 1272.48 388.524 1267.99 389.648C1263.5 390.771 1236.25 377.29 1228.39 374.482C1220.52 371.673 1215.47 348.643 1214.35 346.116C1213.22 343.869 1212.66 327.018 1212.1 323.086C1211.54 319.154 1204.24 314.098 1201.43 323.647C1198.62 333.196 1199.74 355.945 1200.3 362.124C1200.87 368.303 1200.3 381.222 1203.11 384.592C1205.92 387.962 1223.9 403.69 1225.58 405.937C1227.27 408.184 1234.01 430.09 1236.25 433.741C1238.5 437.112 1257.6 444.414 1270.8 452.278C1283.72 460.141 1297.48 472.499 1297.48 472.499C1297.48 472.499 1293.55 476.993 1297.48 480.924C1301.41 484.856 1308.71 487.665 1308.71 487.665L1320.51 516.031L1354.77 480.082Z",
    fill: "#B5B5B5",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.25 434.304C1234.01 430.934 1227.27 409.027 1225.58 406.5C1223.9 404.253 1205.92 388.525 1203.11 385.155C1200.3 381.785 1200.87 368.865 1200.3 362.687C1199.74 356.508 1198.62 333.759 1201.43 324.21C1204.24 314.661 1211.54 319.716 1212.1 323.648C1212.66 327.58 1213.22 344.431 1214.35 346.678C1215.47 348.925 1220.53 371.955 1228.39 375.044C1236.25 377.853 1263.5 391.333 1267.99 390.21C1272.48 389.087 1282.03 380.661 1283.16 378.976C1284.28 377.291 1284.84 370.55 1284.84 362.125C1284.84 353.699 1285.96 344.15 1291.02 337.41C1296.07 330.669 1303.38 331.231 1302.82 338.533C1302.25 345.835 1302.25 366.899 1302.82 373.078C1303.38 379.257 1314.61 398.917 1317.98 405.938C1321.35 412.678 1321.91 443.291 1322.47 445.538C1322.76 446.661 1330.9 455.649 1339.04 464.355L1308.99 490.193L1308.43 489.07C1308.43 489.07 1301.13 486.262 1297.2 482.33C1293.27 478.398 1297.2 473.904 1297.2 473.904C1297.2 473.904 1283.72 461.546 1270.52 453.683C1257.6 445.257 1238.5 437.955 1236.25 434.304Z",
    fill: "#FDFDFD",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.58 406.78L1244.68 420.823",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1605.85 439.36C1605.85 439.36 1576.65 434.305 1559.51 448.066C1542.38 461.828 1536.2 487.666 1535.36 490.194C1534.52 492.722 1453.63 566.586 1453.63 566.586L1352.25 473.062L1302.53 521.93C1302.53 521.93 1366.01 602.816 1398.87 633.71C1431.73 664.603 1455.6 678.927 1461.78 681.735C1467.68 684.263 1473.85 681.735 1480.59 677.522C1487.33 673.31 1630.01 529.794 1630.01 529.794",
    fill: "#DFE33D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1605.85 439.36C1605.85 439.36 1576.65 434.305 1559.51 448.066C1542.38 461.828 1536.2 487.666 1535.36 490.194C1534.52 492.722 1453.63 566.586 1453.63 566.586L1352.25 473.062L1302.53 521.93C1302.53 521.93 1366.01 602.816 1398.87 633.71C1431.73 664.603 1455.6 678.927 1461.78 681.735C1467.68 684.263 1473.85 681.735 1480.59 677.522C1487.33 673.31 1630.01 529.794 1630.01 529.794",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1607.82 499.462C1607.82 499.462 1581.14 474.466 1567.38 473.623C1553.62 472.781 1544.07 484.015 1544.07 484.015",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1621.58 478.959C1621.58 478.959 1589 457.614 1569.9 467.725",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.91 566.586C1453.91 566.586 1476.38 613.769 1472.73 636.237",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1458.13 569.113C1458.13 569.113 1481.44 583.718 1489.86 611.241",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.4 336.285H1245.24C1248.61 336.285 1251.14 333.476 1251.14 330.387V292.753H1238.22V330.387C1238.5 333.757 1241.03 336.285 1244.4 336.285Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.41 284.89H1254.51V297.809H1235.41V284.89Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.24 336.285H1221.09C1224.46 336.285 1226.98 333.476 1226.98 330.387V292.753H1214.07V330.387C1214.07 333.757 1216.87 336.285 1220.24 336.285Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.98 284.89H1230.07V297.809H1210.98V284.89Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.64 312.414H1288.21V354.823H1205.64V312.414Z",
    fill: "#969696",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M842.86 418.699H810.738V454.691H842.86V418.699Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M855.244 404.767H794.096V426.826H855.244V404.767Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M893.945 443.468H756.557V810.352H893.945V443.468Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M809.964 588.209C829.628 588.209 845.568 572.268 845.568 552.604C845.568 532.94 829.628 516.999 809.964 516.999C790.3 516.999 774.359 532.94 774.359 552.604C774.359 572.268 790.3 588.209 809.964 588.209Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M991.672 903.621L928.59 824.671H746.695L684 903.621H991.672Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M990.124 825.445H740.89C728.893 825.445 718.831 815.77 718.831 803.386V801.838H1011.8V803.386C1012.18 815.77 1002.12 825.445 990.124 825.445Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.85 318.89L945.733 354.812L952.917 365.837L1008.04 329.914L1000.85 318.89Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.18 280.736L980.623 314.334L1002.18 347.406L1053.73 313.808L1032.18 280.736Z",
    fill: "#D7D7D7",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M831.249 231H818.865V271.249H831.249V231Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M837.054 268.539H811.899V347.876H837.054V268.539Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M853.696 339.361H795.258V385.028H853.696V339.361Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M948.126 317.303L881.56 373.806L734.11 386.577L737.593 424.504L915.23 409.024L975.604 364.131L948.126 317.303Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.89 894.935H1079.43C1070.39 894.935 1063 887.542 1063 878.506V711.75H1098.73V878.506C1098.32 887.542 1090.93 894.935 1081.89 894.935Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.59 779.108V876.861C1062.59 886.719 1070.39 894.522 1080.25 894.522C1090.11 894.522 1097.91 886.719 1097.91 876.861V778.697H1062.59V779.108Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.49 706H1056.43V739.68H1104.49V706Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.67 894.935C1139.81 894.935 1132 887.131 1132 877.273V711.75H1167.74V876.863C1167.74 886.72 1159.52 894.935 1149.67 894.935Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1132 779.108V876.861C1132 886.719 1139.81 894.522 1149.67 894.522C1159.52 894.522 1167.33 886.719 1167.33 876.861V778.697H1132V779.108Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.9 706H1125.84V739.68H1173.9V706Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.08 894.935C1209.22 894.935 1201.42 887.131 1201.42 877.273V711.75H1237.15V876.863C1237.15 886.72 1228.94 894.935 1219.08 894.935Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.42 779.108V876.861C1201.42 886.719 1209.22 894.522 1219.08 894.522C1228.94 894.522 1236.74 886.719 1236.74 876.861V778.697H1201.42V779.108Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1242.9 706H1194.85V739.68H1242.9V706Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.49 894.935C1278.63 894.935 1270.83 887.131 1270.83 877.273V711.75H1306.56V876.863C1306.56 886.72 1298.35 894.935 1288.49 894.935Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.83 779.108V876.861C1270.83 886.719 1278.63 894.522 1288.49 894.522C1298.35 894.522 1306.15 886.719 1306.15 876.861V778.697H1270.83V779.108Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.31 706H1264.26V739.68H1312.31V706Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1342.71 757.752H1032.2V768.431H1342.71V878.506H1017V903.971H1364.07V897.81V878.506V768.431V757.752H1342.71Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.514 263.78H474.592L491.889 91H363.81L346.514 263.78Z",
    fill: "#E8E8E8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.514 263.78H474.592L491.889 91H363.81L346.514 263.78Z",
    stroke: "#E8E8E8",
    strokeWidth: 5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.601 263.78H470.062L487.36 91H356.897L339.601 263.78Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.601 263.78H470.062L487.36 91H356.897L339.601 263.78Z",
    stroke: "#E8E8E8",
    strokeWidth: 5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.589 240.968H449.643L462.371 113.814H377.317L364.589 240.968Z",
    fill: "#E8E8E8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.74 217.353C152.74 226.516 160.17 233.945 169.334 233.945H318.627V200.759H169.334C160.17 200.759 152.74 208.188 152.74 217.353Z",
    fill: "#005D5F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.153 217.353C253.153 222.657 257.453 226.958 262.759 226.958H318.226C318.448 226.958 318.627 226.78 318.627 226.56V208.144C318.627 207.924 318.448 207.746 318.226 207.746H262.759C257.453 207.746 253.153 212.047 253.153 217.353Z",
    fill: "#E8E8E8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.903 233.945V267.132H294.855C304.02 267.132 311.449 259.702 311.449 250.539C311.449 241.375 304.02 233.945 294.855 233.945H131.903Z",
    fill: "#005D5F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.903 241.027V260.055H198.903C204.157 260.055 208.417 255.795 208.417 250.541C208.417 245.286 204.157 241.027 198.903 241.027H131.903Z",
    fill: "#E8E8E8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79 289.178H640.733V265.581H79V289.178Z",
    fill: "#E8E8E8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640.733 289.178H733.143V265.581H640.733V289.178Z",
    fill: "#005D5F"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.91 289.18L259.777 358.001V289.18H215.91Z",
    fill: "#E9E9E9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.635 289.18L235.502 358.001H259.777L215.91 289.18H191.635Z",
    fill: "#005D5F"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.645 289.18L581.512 358.001V289.18H537.645Z",
    fill: "#E9E9E9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.369 289.18L557.236 358.001H581.512L537.645 289.18H513.369Z",
    fill: "#005D5F"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M564.768 254.529L545.937 181.485V161.513H519.307V181.485L500.475 254.529C499.144 259.475 502.948 264.23 507.894 264.23H557.16C562.486 264.23 566.1 259.475 564.768 254.529Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M549.551 217.627H516.073L506.182 256.051C505.992 256.812 506.372 257.573 506.562 257.763C506.752 258.143 507.323 258.524 508.084 258.524H557.35C558.301 258.524 558.682 257.953 558.872 257.763C559.062 257.573 559.443 256.812 559.252 256.051L549.551 217.627Z",
    fill: "#00415F"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M618.98 195.18V152.952H594.252V195.18C580.746 200.126 570.855 213.251 570.855 228.659C570.855 248.441 586.833 264.419 606.616 264.419C626.399 264.419 642.377 248.441 642.377 228.659C642.377 213.251 632.676 200.126 618.98 195.18Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M576.182 219.528C575.421 222.382 574.85 225.425 574.85 228.659C574.85 246.349 589.116 260.615 606.807 260.615C624.497 260.615 638.763 246.349 638.763 228.659C638.763 225.425 638.383 222.572 637.432 219.528H576.182Z",
    fill: "#00415F"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M692.405 218.576V141.348H676.046V218.576C667.106 221.81 660.638 230.56 660.638 240.641C660.638 253.576 671.1 264.228 684.225 264.228C697.16 264.228 707.812 253.766 707.812 240.641C707.812 230.56 701.345 222 692.405 218.576Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M664.062 234.744C663.492 236.646 663.111 238.548 663.111 240.641C663.111 252.244 672.432 261.755 684.225 261.755C695.828 261.755 705.339 252.434 705.339 240.641C705.339 238.548 704.959 236.646 704.388 234.744H664.062Z",
    fill: "#00415F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 806,
    width: 630.987,
    height: 25.7237,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 123.684,
    y: 824.157,
    width: 18.1579,
    height: 96.8421,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 580.658,
    y: 824.157,
    width: 18.1579,
    height: 96.8421,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientist2);
export default __webpack_public_path__ + "static/media/scientist2.4c05ed4ee5857efb990d2bb913039aa5.svg";
export { ForwardRef as ReactComponent };